import { find, slice } from 'lodash';
import { ComparatorTypes, comparator } from './comparator';
import { EventHsTypes, clubStatusTypeIds, EventScheduleTypes } from './eventConstants';
import { formatToFixed } from './formatting';
import { ClubSubtypes } from './constants';
import clubs from '../../constants/clubs';

const _ = { find, slice };
const { RECENT, UPCOMING, INPROGRESS } = EventScheduleTypes;
const CURRENT_SEASON_START_DATE = new Date(new Date().getFullYear(), 6, 15);

export const ClubTierTypes = {
    PERSONAL: 1,
    PRO: 2,
    SPECIAL: 3,
    FREE_COLLEGE: 4,
    HIGH_SCHOOL: 5,
    PRO_COLLEGE: 6,
    PREMIUM: 7,
    TOURNAMENT: 8,
    PREMIUM_LITE: 9,
    PREMIUM_ZERO_TEN: 10,
    CREATE_PLAY: 11,
    MATCH_PLAY: 12,
    FLEX_LEAGUE: 13,
    TEAM_LEAGUE: 14, // obsolete
    ADULT_TEAM: 15,
    PAID_HIT: 16,
    PERFORMANCE_HIGH_SCHOOL: 17,
    PREMIUM_TEN: 18,
};

export const ClubMemberRoles = {
    Owner: 1,
    Admin: 2,
    Member: 3,
};

export function isActive(club) {
    const { statusType, statusTypeId } = club;
    if ((statusType || statusTypeId) && (
        statusType?.value?.toLowerCase() === 'active' || statusTypeId === clubStatusTypeIds.ACTIVE ||
        statusType?.value?.toLowerCase() === 'overdue' || statusTypeId === clubStatusTypeIds.OVERDUE ||
        statusType?.value?.toLowerCase() === 'paymentrequired' || statusTypeId === clubStatusTypeIds.PAYMENT_REQUIRED
    )) {
        return true;
    }
    return false;
}

export function paymentRequired(club) {
    const { statusType, statusTypeId } = club;
    if ((statusType?.value?.toLowerCase() === 'paymentrequired') ||
        (statusTypeId === clubStatusTypeIds.PAYMENT_REQUIRED)

    ) {
        return true;
    }
    return false;
}

export function isPaymentProviderActive(clubDetails, paymentProvider) {
    return clubDetails?.activePaymentProviderTypes?.find(payment => payment.value === paymentProvider);
}

export function suspended(club) {
    const { statusType, statusTypeId } = club;
    if ((statusType?.value?.toLowerCase() === 'suspended') ||
        (statusTypeId === clubStatusTypeIds.SUSPENDED)
    ) {
        return true;
    }
    return false;
}

export const getClubTierTypeDisplay = (clubTierTypeName, includeTeamDescriptor) => {
    switch (clubTierTypeName?.toLowerCase()) {
        case 'personal':
            return 'Personal Club';
        case 'pro':
            return 'Pro Club';
        case 'enterprise':
            return 'Enterprise Club';
        case 'special':
            return 'Premium Club';
        case 'free college':
            return `College Coach ${includeTeamDescriptor ? 'Team' : ''}`.trimEnd();
        case 'high school':
            return `High School ${includeTeamDescriptor ? 'Team' : ''}`.trimEnd();
        case 'pro college':
            return `College Coach ${includeTeamDescriptor ? 'Team' : ''}`.trimEnd();
        case 'tournament':
            return 'Tournament Club';
        case 'premium lite':
            return 'Club';
        case 'premium zero ten':
            return 'Club';
        default:
            return '';
    }
};

export const canRunEvents = (club) => {
    return club.canRunEvents;
};

export const getClubConceptDisplay = (clubTierTypeName) => {
    switch (clubTierTypeName?.toLowerCase()) {
        case 'free college':
        case 'high school':
        case 'pro college':
            return 'Team Website';
        case 'adult team':
            return 'Registration';
        default:
            return 'Organizer Website';
    }
};

export const getClubGenderDisplay = (clubTierType, clubSubTypeId) => {
    switch (clubTierType?.name?.toLowerCase()) {
        case 'high school':
            if (clubSubTypeId === 1) {
                return `Boys`;
            } if (clubSubTypeId === 2) {
                return `Girls`;
            }
            return `Boys and Girls`;

        case 'free college':
        case 'pro college':
            if (clubSubTypeId === 1) {
                return `Men's`;
            } if (clubSubTypeId === 2) {
                return `Women's`;
            }
            return '';

        default:
            return '';
    }
};

export const getClubNameDisplay = (tierType, schoolProfile, name) => {
    if (!tierType) {
        return name;
    }
    switch (tierType.name?.toLowerCase()) {
        case 'free college':
        case 'pro college':
            if (schoolProfile) {
                return schoolProfile.shortName ? schoolProfile.shortName : schoolProfile.name;
            }
            return name;
        default:
            return name;
    }
};

export const isFlexLeagueClub = (tierType) => {
    return tierType?.name?.toLowerCase() === 'flex league club';
};

export const isFlexLeagueClubV2 = (tierTypeId) => {
    return tierTypeId === ClubTierTypes.FLEX_LEAGUE;
};

export const isTeamTennisClub = (tierType) => {
    return tierType?.name?.toLowerCase() === 'adult team';
};
export const isTeamTennisClubV2 = (tierTypeId) => {
    return tierTypeId === ClubTierTypes.ADULT_TEAM;
};

export const isTournamentClub = (tierType) => {
    return tierType?.name?.toLowerCase() === 'tournament';
};

export const isCoachClub = (tierType) => {
    return tierType?.name?.toLowerCase() === 'coach';
};

export const isPersonalClub = (tierType) => {
    return tierType?.name?.toLowerCase() === 'personal';
};

export const isPremiumClubs = (tierType) => {
    const tierName = tierType?.name?.toLowerCase();
    return tierType?.name && ((tierName === 'tournament') || (tierName === 'enterprise') || (tierName === 'pro'));
};

export const isClubOwner = (club) => {
    return club?.currentMember?.role === 'Owner';
};

export const isClubAdminOrOwner = (club) => {
    return (club?.currentMember?.role === 'Owner' || club?.currentMember?.role === 'Admin');
};

export const isProCollegeClubAdminOrOwner = (club) => {
    const tierName = club?.tierType?.name?.toLowerCase() || '';
    return club && tierName === 'pro college' && club.currentMember && (club.currentMember.role === 'Owner' || club.currentMember.role === 'Admin');
};

export const isClubAdminOrMember = (club) => {
    return (club?.currentMember?.role === 'Admin' || club?.currentMember?.role === 'Member');
};

export const isClubMember = (club) => {
    return (club?.currentMember?.role === 'Owner' || club?.currentMember?.role === 'Admin' || club?.currentMember?.role === 'Member');
};

export const clubSubTypeId = (club) => {
    // TODO - this will return undefined if no club exists, is this what we want? or it to be 0?
    return club?.clubSubType ? club.clubSubType.id : 0;
};

export const hasSchoolLinked = (club) => {
    return club?.clubHasSchool;
};

export const showPrivateClubData = (club) => {
    return (club && !club.private) || isClubMember(club);
};

export const isCollegeClub = (tierTypeName) => {
    return tierTypeName?.toLowerCase() === 'free college' || tierTypeName?.toLowerCase() === 'pro college';
};

export const isCollegeClubByTierTypeId = (tierTypeId) => {
    return tierTypeId === ClubTierTypes.FREE_COLLEGE || tierTypeId === ClubTierTypes.PRO_COLLEGE;
};

export const isCollegeOrHighSchoolClub = (tierType) => {
    return (tierType?.isCollege || tierType?.isHighSchool);
};

export const isFreeCollegeClub = (tierTypeName) => {
    return tierTypeName?.toLowerCase() === 'free college';
};

export const isFreeCollegeClubOwnerOrAdmin = (club) => {
    return isFreeCollegeClub(club?.tierType?.name) && isClubAdminOrOwner(club);
};

export const isHighSchoolClub = (tierType) => {
    return tierType && (tierType.isHighSchool || tierType === ClubTierTypes.HIGH_SCHOOL || tierType === ClubTierTypes.PERFORMANCE_HIGH_SCHOOL);
};

export const isHighSchoolClubByTierTypeId = (tierTypeId) => {
    return tierTypeId === ClubTierTypes.HIGH_SCHOOL || tierTypeId === ClubTierTypes.PERFORMANCE_HIGH_SCHOOL;
};

export const isFreeHighSchoolClub = (tierTypeName) => {
    return tierTypeName?.toLowerCase() === 'high school';
};

export const getRequestToJoinDisplayData = (clubDetails, requestToJoinButtonHover) => {
    const { tierType } = clubDetails;
    const currentMemberRole = (clubDetails && clubDetails.currentMember && clubDetails.currentMember.role)
        ? clubDetails.currentMember.role
        : '';
    const isAdminOrOwner = currentMemberRole === 'Owner' || currentMemberRole === 'Admin';
    let showRequestToJoin = false;
    let requestToJoinEnabled = false;
    let requestToJoinText = tierType && (tierType.isHighSchool || tierType.isCollege) ? 'Follow' : 'Request to join';
    if (clubDetails.currentMember && !isAdminOrOwner) {
        if (!isTournamentClub(clubDetails.tierType)) {
            showRequestToJoin = true;
        }
        if (clubDetails.currentMember.role === 'Member') {
            if (requestToJoinButtonHover === true) {
                if (tierType.isHighSchool || tierType.isCollege) {
                    requestToJoinText = 'Unfollow';
                } else if (isPersonalClub(tierType)) {
                    requestToJoinText = 'Leave The Group';
                } else {
                    requestToJoinText = 'Leave The Club';
                }
                requestToJoinEnabled = true;
            } else {
                requestToJoinText = 'You\'re a Member';
            }
        } else if (clubDetails.currentMember.role === 'Follower') {
            if (requestToJoinButtonHover === true) {
                if (tierType.isHighSchool || tierType.isCollege) {
                    requestToJoinText = 'Unfollow';
                } else if (isPersonalClub(tierType)) {
                    requestToJoinText = 'Leave The Group';
                } else {
                    requestToJoinText = 'Leave The Club';
                }
                requestToJoinEnabled = true;
            } else {
                requestToJoinText = 'Following';
            }
        } else if (clubDetails.currentMember.clubMemberRequest && clubDetails.currentMember.clubMemberRequest.status === 'Pending') {
            requestToJoinEnabled = false;
            requestToJoinText = 'Request to Join - Pending';
        } else {
            requestToJoinEnabled = true;
        }
    }
    return {
        showRequestToJoin,
        requestToJoinEnabled,
        requestToJoinText,
    };
};

export const checkIfMemberIsOrganizer = (clubDetails, memberId) => {
    if (clubDetails && clubDetails.clubMembers) {
        const member = _.find(clubDetails.clubMembers, { memberId });

        if (member && member.role && (member.role === 'Admin' || member.role === 'Owner')) {
            return true;
        }
    }
    return false;
};

export const EventTypes = {
    TMS: 'tms',
    TEAM_MATCHES: 'teamMatches',
    LEAGUES: 'leagues',
    LEGACY: 'other',
};

export const getClubEventComparatorParams = (descend) => {
    return [
        {
            type: ComparatorTypes.DATE,
            field: 'momentStartDate',
            descend,
        },
        {
            type: ComparatorTypes.STRING,
            field: 'name',
        },
    ];
};

export const getEventsListByEventType = (clubDetails, recentOrUpcoming, eventtype, tmsEventsFetchState, hsEventType) => {
    let eventsList = [];
    if (!clubDetails.tierType) {
        return eventsList;
    }
    switch (recentOrUpcoming) {
        case INPROGRESS:
        case UPCOMING:
            if (clubDetails.tierType.isHighSchool) {
                if (clubDetails.tmsEventsUpcoming) {
                    eventsList = eventsList.concat(clubDetails.tmsEventsUpcoming);
                    if (hsEventType) {
                        eventsList = eventsList.filter(e => e.hsEventType && e.hsEventType.id === hsEventType);
                    }
                }
                if (clubDetails.teamMatchesUpcoming) {
                    if (EventHsTypes.OTHER !== hsEventType) {
                        eventsList = eventsList.concat(clubDetails.teamMatchesUpcoming);
                    }
                }
                eventsList.sort(comparator(getClubEventComparatorParams(false)));
            } else if (eventtype === EventTypes.TEAM_MATCHES) {
                eventsList = clubDetails.teamMatchesUpcoming;
            } else {
                eventsList = clubDetails.tmsEventsUpcoming;
            }
            break;
        case RECENT:
            if (clubDetails.tierType.isHighSchool) {
                const eventCount = isClubAdminOrOwner(clubDetails) ? clubDetails.tmsEventsCount + clubDetails.demoEventCount : clubDetails.tmsEventsCount;
                let fetchedAllEvents = tmsEventsFetchState ? tmsEventsFetchState.eventsFetched >= eventCount : true;
                let lastTmsEventDate;
                if (clubDetails.tmsEventsRecent) {
                    eventsList = eventsList.concat(clubDetails.tmsEventsRecent);
                    if (hsEventType) {
                        eventsList = eventsList.filter(e => e.hsEventType && e.hsEventType.id === hsEventType);
                    }
                    if (eventsList && eventsList.length > 0) {
                        lastTmsEventDate = eventsList[eventsList.length - 1].momentStartDate;
                    } else {
                        fetchedAllEvents = true;
                    }
                }
                if (clubDetails.teamMatchesRecent) {
                    if (fetchedAllEvents) {
                        if (EventHsTypes.OTHER !== hsEventType) {
                            eventsList = eventsList.concat(clubDetails.teamMatchesRecent);
                        }
                    } else {
                        const fileredEvents = clubDetails.teamMatchesRecent.filter(event => event.momentStartDate.isAfter(lastTmsEventDate) || event.momentStartDate.isSame(lastTmsEventDate));
                        if (EventHsTypes.OTHER !== hsEventType) {
                            eventsList = eventsList.concat(fileredEvents);
                        }
                    }
                }
                eventsList.sort(comparator(getClubEventComparatorParams(true)));
            } else if (eventtype === EventTypes.TEAM_MATCHES) {
                eventsList = clubDetails.teamMatchesRecent;
            } else {
                eventsList = clubDetails.tmsEventsRecent;
            }
            break;
        case 'draft':
            if (clubDetails.tierType.isHighSchool) {
                if (clubDetails.draftEvents) {
                    eventsList = eventsList.concat(clubDetails.draftEvents);
                    if (hsEventType) {
                        eventsList = eventsList.filter(e => e.hsEventType && e.hsEventType.id === hsEventType);
                    }
                }
                eventsList.sort(comparator(getClubEventComparatorParams(false)));
            } else {
                eventsList = clubDetails.draftEvents;
            }
            break;
        default:
            break;
    }
    return eventsList;
};

export const getEventsFromIndex = (eventsList, start, count) => {
    const eventsCount = eventsList ? eventsList.length : 0;
    if (eventsList != null && start != null && count != null && eventsCount > 0 && eventsCount > count) {
        const startIndex = eventsCount > start ? start : eventsCount - count - 1;
        const endIndex = eventsCount > start ? start + count : eventsCount;
        return _.slice(eventsList, startIndex, endIndex);
    }
    return eventsList;
};

export const getClubTypeString = (tierTypeId) => {
    switch (tierTypeId) {
        case 1:
            return 'groups';
        case 4:
        case 6:
            return 'colleges';
        case 5:
            return 'schools';
        default:
            return 'clubs';
    }
};

export const memberTypes = [
    'Member',
    'Admin',
    'Owner',
];

export const getClubGenderPower6 = (subTypeId) => {
    if (subTypeId === 1) {
        return 'm';
    } if (subTypeId === 2) {
        return 'f';
    }
    return '';
};

export const displayNameForRole = (role) => {
    if (role) {
        const roleName = role.toLowerCase();
        if (roleName === 'owner') {
            return 'Head Provider';
        }
        if (roleName === 'admin') {
            return 'Provider';
        }
        if (roleName === 'formermember') {
            return 'Former Member';
        }
        if (roleName === 'formerfollower') {
            return 'Former Follower';
        }
        if (roleName === 'member') {
            return 'Member';
        }
        return 'member';
    }
    return role;
};

export const getClubsWhereUserIsAdmin = (user = {}) => {
    const clubIds = [];
    user.clubMemberships.forEach(club => {
        if (club.roleId === 1 || club.roleId === 2) {
            clubIds.push(club.clubId);
        }
    });
    return clubIds;
};

export const getClubsVisibleToUser = (clubs = []) => {
    const { CREATE_PLAY } = ClubTierTypes;
    const hiddenClubTypes = [CREATE_PLAY];
    return clubs?.filter(club => !hiddenClubTypes.includes(club.tierTypeId));
};

export const sortClubMembershipsByPaidHit = (clubs = []) => {
    const { PAID_HIT } = ClubTierTypes;
    const paidHitClub = clubs?.find(club => club.tierTypeId === PAID_HIT);
    const filteredClubs = clubs?.filter(club => club.tierTypeId !== PAID_HIT);

    if (paidHitClub) {
        return [paidHitClub, ...filteredClubs];
    }
    return clubs;
};

export const ClubMemberCardTypes = {
    MEMBER: 'member',
    REQUEST: 'request',
    INVITE: 'invite',
    FORMER_MEMBER: 'formermember',
};

export const displayMembershipType = (type, clubDetails) => {
    return (type === ClubMemberCardTypes.MEMBER) && (clubDetails.isEnterprise || clubDetails.isPro || clubDetails.isPremium || clubDetails.isProCollege);
};

export const displayBillingStatus = (type, isAdminOrOwner, clubDetails) => {
    return (type === ClubMemberCardTypes.MEMBER || type === ClubMemberCardTypes.FORMER_MEMBER) && (isAdminOrOwner) && (clubDetails.isEnterprise || clubDetails.isPremium || clubDetails.isProCollege);
};

export const currentMemberIsAdmin = (clubDetails) => {
    return clubDetails.currentMember && (clubDetails.currentMember.role === 'Admin' || clubDetails.currentMember.role === 'Owner');
};

export const hasCurrentSeasonStarted = () => {
    return new Date() >= CURRENT_SEASON_START_DATE;
};

export const getClubsEmail = (clubTierType) => {
    if (clubTierType?.isCollege) {
        return clubs.collegeTeamEmail;
    }

    if (clubTierType?.isHighSchool) {
        return clubs.highSchoolTeamEmail;
    }

    return clubs.clubsEmail;
};

export const calculatePower6FromPlayers = (team, originalTop6 = {}) => {
    const filtered = team.roster.filter(p => p.isIncluded && p.ratingProgressSingles != null);
    const top6 = filtered.slice(0, 6);

    if (team.clubSubTypeId === ClubSubtypes.COED) {
        const sum = top6.reduce((sum, player) => sum + (player.singlesUtr || 0), 0);
        return formatToFixed(sum);
    }

    const top6Ids = top6.map(p => p.id).sort();
    const originalIds = originalTop6[team.teamId]?.slice().sort() || [];

    if (JSON.stringify(top6Ids) === JSON.stringify(originalIds)) {
        return formatToFixed(team.power6);
    }

    const sum = top6.reduce((sum, player) => sum + (player.singlesUtr || 0), 0);
    return formatToFixed(sum);
};

export const getNewClubPath = (clubTierTypeId) => {
    switch (clubTierTypeId) {
        case ClubTierTypes.FREE_COLLEGE:
        case ClubTierTypes.PRO_COLLEGE: {
            return 'college';
        }
        case ClubTierTypes.HIGH_SCHOOL:
        case ClubTierTypes.PERFORMANCE_HIGH_SCHOOL: {
            return 'high-school';
        }
        default:
            return 'club';
    }
};
